import { CanActivateFn, Router } from '@angular/router';
import { getCurrentUser } from '@aws-amplify/auth';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LocaleService } from './services/locale';

export const dashGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const toastr = inject(ToastrService);
  const locale = inject(LocaleService).locale();

  try {
    const user = await getCurrentUser();
    if (user?.userId) {
      return true;
    }
  } catch (error) {
    // User is not authenticated
  }

  toastr.error(locale.common.login_required || 'Please login to continue');
  return router.createUrlTree(['/login']);
};

// Guard to prevent logged-in users from accessing auth pages
export const guestGuard: CanActivateFn = async () => {
  const router = inject(Router);

  try {
    const user = await getCurrentUser();
    if (user?.userId) {
      // User is already logged in, redirect to dashboard
      return router.createUrlTree(['/dashboard/calculations']);
    }
  } catch (error) {
    // User is not authenticated, allow access to auth pages
  }

  return true;
};

// Training videos are available to all authenticated users
export const trainingGuard: CanActivateFn = async () => {
  return true;
};
